import produce from "immer";
import * as constants from "../../utils/constants";
import { GlobalState } from "../../schemas/schema";

export const initalState: GlobalState = {
  lastUpdatedDate: "",
  loading: false,
  loadCount: 0,
  error: false,
  currentUser: false,
  hasSession: 0,
  userData: null,
  showPermissionAlert: false,
  permissionAlertMessage: "",
  permissionAlertTitle: "",
  alertError: false, //  not using this.
  networkStatus: { connected: false, connectionType: "none" },
  deviceInfo: {},
  Hidden: true,
  loginToken: "",
  deepLinkURI: "",
  notificationData: {
    shipmentId: "",
    userId: "",
    carrierName: "",
    carrierId: "",
    Timestamp: "",
    deepLinkURI: "",
  },
  showPullToRefresh: false,
  userPreferences: [],
  userPreferencesDomain: "",
  validMobileNumberMSsg: {}
};


const appReducer = (state = initalState, action: any) =>
  produce(state, draft => {
    switch (action.type) {
      case constants.LAST_UPDATED_DATE:
        draft.lastUpdatedDate = action.date;
        break;
      case constants.TOGGLE_LOADING:
        const count = action.status ? draft.loadCount + 1 : draft.loadCount - 1;
        draft.loadCount = count >= 0 ? count : 0;
        draft.loading = count > 0 ? true : false;
        break;
      case constants.PERMISSION_ALERT_MESSAGE:
        draft.showPermissionAlert = action.payload.isShowPermissionAlert;
        draft.permissionAlertMessage = action.payload.permissionAlertMessage;
        draft.permissionAlertTitle = action.payload.permissionAlertTitle;
        break;
      case constants.CLOSE_PERMISSION_ALERT:
        draft.showPermissionAlert = false;
        draft.permissionAlertMessage = "";
        draft.permissionAlertTitle = "";
        break;
      case constants.LOGIN_INPROGRESS:
        draft.error = false;
        break;
      case constants.LOGIN_SUCCESS:
        draft.currentUser = true;
        draft.userData = action.data;
        break;
      case constants.LOGIN_ERROR:
        draft.error = true;
        break;
      case constants.HIDE_TAB_BAR:
        draft.Hidden = false;
        break;
      case constants.LOGOUT:
        draft = initalState;
        break;
      case constants.SESSION:
        draft.hasSession = action.session;
        break;
      case constants.UPDATE_NETWORK_STATUS:
        draft.networkStatus = action.data;
        break;
      case constants.UPDATE_DEVICE_INFO:
        draft.deviceInfo = action.data;
        break;
      case constants.TOKEN_DATA:
        draft.loginToken = action.data.access_token;
        break;
      case constants.SAVE_DEEPLINK_URI:
        draft.notificationData = action.data;
        draft.deepLinkURI = `${action.data.deepLinkURI}/${(action.data.shipmentId ? action.data.shipmentId : "")}`;
        break;
      case constants.CLEAR_DEEPLINK_URI:
        draft.deepLinkURI = "";
        draft.notificationData = {
          shipmentId: "",
          userId: "",
          carrierName: "",
          carrierId: "",
          Timestamp: "",
          deepLinkURI: "",
        };
        break;
      case constants.PULL_TO_REFRESH_LOADING:
        draft.showPullToRefresh = action.status;
        break;
      case constants.SAVE_USER_PREFERENCES:
        draft.userPreferences = action.payload;
        break;
      case constants.SAVE_USER_PREFERENCES_DOMAIN:
        draft.userPreferencesDomain = action.payload;
        break;
        case constants.VALIDATE_MOBILE_NUMBER_SUCCESS:
          draft.validMobileNumberMSsg = action.payload;
          break;
    }
  });

export default appReducer;

